import React from 'react';
import {Spinner} from 'react-bootstrap';


class BooleanQuestion extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showSpinner: false
        };

        this.hideSpinner = this.hideSpinner.bind(this);
    }

    hideSpinner() {
        this.setState({
            showSpinner: false
        });
    }

    render() {
        return (
            <div className="col justify-content-center" id="random-question">
                {this.state.showSpinner && (
                    <div className="spinnerContainer" style={{width: '100%', padding: '25px 0'}}>
                        <Spinner variant="primary" animation="border"/>
                    </div>
                )}
                <p>
                    {this.props.randomQuestion.questionText}
                </p>
            </div>
        );
    }
}

export default BooleanQuestion;
